<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="racksModal" tabindex="-1" role="dialog" aria-labelledby="racksModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader">Create new {{ type }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form v-if="type==='rack'" class="form-horizontal" @submit.prevent="submit()">
              <div class="row">
                <label class="col-sm-2 col-md-2 col-lg-2 text-center col-form-label">Name
                  <strong class="text-danger">*</strong>
                </label>
                <div class="col-sm-10 col-md-10 col-lg-10">
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="value" required >
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12 text-right">
                  <button :disabled="loading" type="submit" class="btn btn-primary ">Save </button>
                </div>

              </div>
            </form>
            <form v-if="type==='node'" class="form-horizontal" @submit.prevent="submit()">
              <div class="row">
                <label class="col-sm-2 col-md-2 col-lg-2 text-center col-form-label">Node ID
                  <strong class="text-danger">*</strong>
                </label>
                <div class="col-sm-10 col-md-10 col-lg-10">
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="nodeId" required >
                  </div>
                </div>
                <label class="col-sm-2 col-md-2 col-lg-2 text-center col-form-label">Node Fname
                  <strong class="text-danger">*</strong>
                </label>
                <div class="col-sm-10 col-md-10 col-lg-10">
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="nodeObj.nodeFname" required >
                  </div>
                </div>
                <label class="col-sm-2 col-md-2 col-lg-2 text-center col-form-label">Node IP
                  <strong class="text-danger">*</strong>
                </label>
                <div class="col-sm-10 col-md-10 col-lg-10">
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="nodeObj.nodeIp" required >
                  </div>
                </div>
                <label class="col-sm-2 col-md-2 col-lg-2 text-center col-form-label">Node Name
                  <strong class="text-danger">*</strong>
                </label>
                <div class="col-sm-10 col-md-10 col-lg-10">
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="nodeObj.nodeName" required >
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12 text-right">
                  <button :disabled="loading" type="submit" class="btn btn-primary ">Save </button>
                </div>

              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Multiselect from 'vue-multiselect'
import {db} from "@/firebase/init";
import swal from "sweetalert2";

export default {
  name: "racksModal",
  components: {
    Multiselect
  },
  data() {
    return {
      loading: false,
      value: '',
      type: '',
       nodeObj: {},
      nodeId: ''

    }
  },
  methods: {
    async load(val) {
      this.type=val
      console.log(this.type)
      $('#racksModal').modal('show');
    },

    async submit(){
      try {
        this.loading=true
        console.log(this.type)
        if(this.type==='node'){
          this.nodeObj.created=new Date().toISOString()
          await  db.collection('nodes').doc(this.nodeId).set(this.nodeObj)
          await this.$parent.$refs.allNodes.getAllNodes()

        }else{
          await  db.collection('racks').add({name: this.value,created: new Date().toISOString() })
          await this.$parent.$refs.allRacks.getAllRacks();


        }
        this.loading=false;

        $('#racksModal').modal('hide');
        this.value=''

        swal({
          title: "Success",
          text: this.type.toUpperCase() +" has been created successfully!",
          type: "success",
        });
      }
      catch(err){
        console.log('error', err)
        this.loading=false;
        swal({
          title: "Error",
          text: "Error while creating " + this.type,
          type: "error",
        });
      }



    }
  }
}
</script>

<style scoped>

</style>
